export const ICandidateProfilePhone = Object.freeze({
  countryCode: "country_code",
  number: "number",
});

export class CandidateProfilePhoneModel {
  constructor(data = {}) {
    this[ICandidateProfilePhone.countryCode] = data[ICandidateProfilePhone.countryCode];
    this[ICandidateProfilePhone.number] = data[ICandidateProfilePhone.number];
  }

  getCountryCode() {
    return this[ICandidateProfilePhone.countryCode];
  }

  getNumber() {
    return this[ICandidateProfilePhone.number];
  }

  getPhoneNumber() {
    if (this[ICandidateProfilePhone.countryCode] && this[ICandidateProfilePhone.number]) {
      return `${this[ICandidateProfilePhone.countryCode]}${this[ICandidateProfilePhone.number]}`;
    } else {
      return "";
    }
  }

  getDisplay() {
    return `+${this.getCountryCode()}${this.getNumber()}`;
  }
}
